import { optionSubcategory_junkEmail } from './junkEmailSubCategory.locstring.json';
import { BlockedSendersAndDomainsOptionV2 } from 'owa-blocked-senders-and-domains-option';
import { FiltersOption } from 'owa-filters-option';
import { initMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { OptionSubCategory } from 'owa-options-core';
import { ReportingOption } from 'owa-reporting-option';
import { SafeMailingListsOptionV2 } from 'owa-safe-mailing-lists-v2-option';
import { SafeSendersDomainsOptionV2 } from 'owa-safe-senders-domains-v2-option';
import { trace } from 'owa-trace';
import { initSpamOption, SpamScenarioId } from 'owa-spam-row-option';

const junkEmailSubCategory: OptionSubCategory = {
    key: 'junkEmail',
    titleStringKey: optionSubcategory_junkEmail,
    options: [
        BlockedSendersAndDomainsOptionV2,
        SafeSendersDomainsOptionV2,
        SafeMailingListsOptionV2,
        FiltersOption,
        ReportingOption,
    ],
    onSelected: () => {
        return loadMailboxJunkEmailConfiguration();
    },
    refreshOnSelected: true,
};

export default junkEmailSubCategory;

async function loadMailboxJunkEmailConfiguration(): Promise<boolean> {
    try {
        await initMailboxJunkEmailConfiguration();

        // Initialize all the spam options
        Object.values(SpamScenarioId).forEach(spanId => {
            if (isNaN(Number(SpamScenarioId[spanId]))) {
                initSpamOption(spanId);
            }
        });

        return true;
    } catch (e) {
        trace.warn(e.message || 'loadMailboxJunkEmailConfiguration failed');
        return false;
    }
}
